import React, { Component } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BarChart, MediumBarChart } from '../../components/bar-chart/';
import styles from './chart-area.module.scss';
import * as selectors from '../../reducers';
import { humanizeNumber } from '../../helpers/formatters';
import { entityLabelMatcher } from '../../helpers/label-mapper';

class ChartArea extends Component {
  constructor() {
    super();
    this.chartMapper = this.chartMapper.bind(this);
  }

  getLegendPhrase(chartData) {
    const { activeCouncil } = this.props;
    const area = activeCouncil[chartData.area];
    return entityLabelMatcher(area, 'plural');
  }

  renderTrend(trend) {
    if (!trend) {
      return null;
    }

    const color = '#9a8273';
    return (
      <span
        style={{
          color,
          marginRight: 10,
        }}
      >
        {trend === '−' ? 'No Trend' : `Trend ${trend}`}
      </span>
    );
  }
  isTextBarChart(data) {
    return data.max === 'High';
  }

  // not the nicest, I'm sorry.
  getAdditionalChartText(title) {
    switch (title) {
      case 'Operating Surplus Ratio': {
        return 'The state government’s target for the council is between 0 and 10 per cent.';
      }
      case 'Net Financial Liabilities': {
        return 'The state government’s target for the council is less than 60 per cent.';
      }
      case 'Asset Sustainability Ratio': {
        return 'The state government’s target for the council is greater than 90 per cent.';
      }
      default: {
        return null;
      }
    }
  }

  chartMapper(chartData, index) {
    const {
      color,
      unit,
      activeCouncil,
      comparedEntity,
      title,
      councils,
      visible,
      trend,
    } = this.props;

    const comparing = comparedEntity !== null;
    const hasDynamicBar = activeCouncil.showMedianOfCategory || comparing;

    switch (chartData.type) {
      case 'main':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={activeCouncil.isBlank || !hasDynamicBar}
            visible={visible}
            isStatic={!hasDynamicBar}
          >
            {this.renderTrend(trend)}
            {hasDynamicBar ? activeCouncil.name : ''}
          </BarChart>
        );
      case 'compared':
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={comparedEntity.isBlank}
            visible={visible}
          >
            {this.renderTrend(trend)}

            {comparedEntity.name}
          </BarChart>
        );
      case 'median':
        const medianCount = councils.filter(
          (council) =>
            council[chartData.area] === activeCouncil[chartData.area] &&
            !council.isBlank
        );
        if (chartData.max === 'High' || !activeCouncil.showMedianOfCategory) {
          // No median for text bar chart or institutions
          return <div key={`empty-${index}`}></div>;
        }
        return (
          <MediumBarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
          >
            <div className={styles.chartLegend}>
              Median of {medianCount ? medianCount.length : 0}{' '}
              <span className={styles.chartLegendBold}>
                {this.getLegendPhrase(chartData)}
              </span>
            </div>
          </MediumBarChart>
        );
      case 'text':
        const additionalText = this.getAdditionalChartText(title);
        return !activeCouncil.showMedianOfCategory ? (
          <div key={index}></div>
        ) : (
          <div key={index} className={styles.chartBottomText}>
            <span>{title}</span> reported for Queensland{' '}
            {entityLabelMatcher(
              activeCouncil.entityCategory,
              'plural'
            ).toLocaleLowerCase()}{' '}
            ranged from {humanizeNumber(chartData.trueMin, unit)} to{' '}
            {humanizeNumber(chartData.max, unit)}.{' '}
            {comparedEntity || this.isTextBarChart(chartData)
              ? null
              : 'Median is the middle value in the selected data range.'}
            {additionalText && additionalText}
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { data } = this.props;
    return data.map((d, i) => this.chartMapper(d, i));
  }
}

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveEntity(state),
  councils: selectors.getEntities(state),
  comparedEntity: selectors.getComparedEntity(state),
});

ChartArea.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedEntity: PropTypes.object,
  data: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js